<template>
  <section class="voucher-box">
    <FloatingActionButtons
      :box="box"
      :index="index"
      :computedBoxesData="boxes"
      :activeFABIndex="activeFABIndex"
      @passActiveIndex="$emit('passActiveIndex', $event)"
      @showDeleteModal="showDeleteModal"
      @showEditModal="showEditModal"
      @showVisibilityModal="showVisibilityModal"
    />
    <div class="column" :style="{ color: box.boxText }">
      <VisibilityModal
        @close="closeWithNo()"
        @editVisibility="editVisibility"
        :box="box"
        v-if="visibilityModalVisible"
      />

      <div class="voucher-wrapper">
        <div
          class="voucher-header"
          v-bind:style="{ backgroundColor: box.boxColor }"
        >
          <div class="voucherImageBox">
            <img v-bind:src="box.iconImage" />
          </div>
          <link
            v-if="customFonts.customFonts"
            :href="customFonts.customFontUrl"
            rel="stylesheet"
          />
          <div v-if="secondLanguage">
            <span
              class="box-title-custom"
              v-if="customFonts.customFonts"
              :style="{
                'font-family': customFonts.customFontCss,
                'font-size': customFonts.customFontSize,
              }"
              >{{ box.titleSec }}</span
            >
            <h4 class="voucher-title h4" v-else :style="{ color: box.boxText }">
              {{ box.titleSec }}
            </h4>
          </div>
          <div v-else>
            <span
              class="box-title-custom"
              v-if="customFonts.customFonts"
              :style="{
                'font-family': customFonts.customFontCss,
                'font-size': customFonts.customFontSize,
              }"
              >{{ box.title }}</span
            >
            <h4 class="voucher-title h4" v-else :style="{ color: box.boxText }">
              {{ box.title }}
            </h4>
          </div>
        </div>
        <div
          class="voucher-footer"
          v-bind:style="{ backgroundColor: box.boxColor }"
        >
          <div class="voucher-footer-text" v-if="!viewConfirm">
            <div>{{ secondLanguage ? box.textSec : box.text }}</div>
          </div>
          <button
            v-bind:style="{
              backgroundColor: box.btnColor,
              color: box.btnTextColor,
            }"
            v-on:click="viewConfirm = true"
            class="gbBtn voucher-redeem"
            v-if="!viewConfirm"
          >
            <span>{{ secondLanguage ? box.buttonSec : box.button }}</span>
          </button>
          <button
            v-bind:style="{
              backgroundColor: box.btnColor,
              color: box.btnTextColor,
            }"
            v-on:click="viewConfirm = false"
            class="gbBtn voucher-cancel"
            v-if="viewConfirm"
          >
            <v-icon name="arrow-left" scale="1.5"></v-icon>
          </button>
          <button
            v-bind:style="{
              backgroundColor: box.btnColor,
              color: box.btnTextColor,
            }"
            v-on:click="viewConfirm = false"
            class="gbBtn voucher-confirm"
            v-if="viewConfirm"
          >
            <span>{{
              secondLanguage ? box.buttonConfirmSec : box.buttonConfirm
            }}</span>
          </button>
        </div>
      </div>
    </div>
    <transition name="fadeInModal">
      <voucher-box-edit
        :box="box"
        :selectedBoxIndex="index"
        :completeBoxArray="boxes"
        :style="{ zIndex: '99' }"
        @close="closeEditModal"
        v-if="showVoucherEditModal"
      >
      </voucher-box-edit>
    </transition>
    <transition name="fadeInModal">
      <confirm-modal
        @yes="closeWithYes()"
        @no="closeWithNo()"
        v-if="showConfirmModal"
      >
        <h2 slot="title">Delete Box?</h2>
        <p slot="description">The box and its content will be deleted</p>
      </confirm-modal>
    </transition>
  </section>
</template>

<script>
import FloatingActionButtons from "../../BoxesComponents/FloatingActionButtons";
import VoucherBoxEdit from "./VoucherBoxEdit";
import ConfirmModal from "@/components/GlobalComponents/ConfirmModal.vue";
import VisibilityModal from "@/components/EditGuestbookPage/BoxesComponents/VisibilityModal.vue";
import bus from "@/bus.js";
import { db, firestore } from "@/firebase";

export default {
  components: {
    FloatingActionButtons,
    VoucherBoxEdit,
    ConfirmModal,
    VisibilityModal,
  },
  props: {
    box: Object,
    index: Number,
    activeFABIndex: Number,
    boxes: Array,
    customFonts: Object,
    languageTypesIndex: Number,
  },
  data() {
    return {
      viewConfirm: false,
      showVoucherEditModal: false,
      showConfirmModal: false,
      visibilityModalVisible: false,
      visibilityEdited: false,
    };
  },
  computed: {
    secondLanguage() {
      if (this.languageTypesIndex === 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    showDeleteModal() {
      this.showConfirmModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showEditModal() {
      this.showVoucherEditModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showVisibilityModal() {
      this.visibilityModalVisible = true;
      this.visibilityEdited = false;
      this.$emit("toggleModal", true);
    },
    editVisibility(payload) {
      this.box.visibility = payload;
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/${this.index}`).set(this.box);
      this.visibilityEdited = true;
    },
    closeEditModal() {
      this.showVoucherEditModal = false;
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithYes: function () {
      this.showConfirmModal = false;
      if (this.box.counter == 0) {
        this.deleteVoucherStatistics(this.box.id);
      } else {
        this.deactivateVoucher(this.box.id);
      }
      this.$toastEvents.push({
        type: "copy",
        title: "Deletion",
        content: "The box has been deleted",
        id: +new Date(),
      });
      this.deleteBox(this.index);
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithNo: function () {
      if (this.showConfirmModal) {
        this.showConfirmModal = false;
      } else if (this.visibilityModalVisible) {
        this.visibilityModalVisible = false;
        if (this.visibilityEdited) {
          this.$toastEvents.push({
            type: "copy",
            title: "Visibility",
            content: "The visibility has been edited",
            id: +new Date(),
          });
        }
      }
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    deleteBox(boxIndex) {
      var newObjToFirebase = this.boxes;
      newObjToFirebase.splice(boxIndex, 1);
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(newObjToFirebase);
    },
    deactivateVoucher(voucherID) {
      return firestore
        .doc(`VoucherStatistics/${this.$hotelId}/Vouchers/${voucherID}`)
        .update({ Active: false });
    },
    deleteVoucherStatistics(voucherID) {
      return firestore
        .doc(`VoucherStatistics/${this.$hotelId}/Vouchers/${voucherID}`)
        .delete();
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

h4 {
  margin: 0px;
}

button {
  cursor: pointer;
}

.wrapCenter {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

.voucher-box {
  height: 100%;
}

/* Create three equal columns that floats next to each other */
.column {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

.iconBox {
  height: 70px;
  overflow: hidden;
  margin-top: 8px;
}

.iconImageBox {
  height: 70px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 5px;
}

.iconImageBox > img {
  max-height: 100%;
  max-width: 100%;
}

.box-title {
  font-size: 1.1em;
  margin-top: auto;
  margin-bottom: auto;
  min-height: 30px;
  display: flex;
  justify-content: center;
}

.box-title-custom {
  margin-top: 10px;
  margin-bottom: 5px;
  display: block;
  font-size: 2.5em;
  line-height: 1;
}

.box-content {
  margin: 0 auto;
  line-height: 1.3em;
}

.box-footer {
  margin-top: auto;
  border-radius: 8px;
  min-height: 8px;
}

.gbBtn {
  height: 45px;
  padding: 0px 9px;
  margin-bottom: 13px;
  border: 2px solid transparent;
  width: calc(100% - 26px);
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  overflow-x: hidden;
}

.voucher-title {
  margin-top: 20px;
  margin-bottom: 16px;
}
.voucherImageBox {
  width: 100%;
  max-height: 100px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 8px 8px 0px 0px;
}
.voucherImageBox > img {
  width: 100%;
  height: 100px;
  object-fit: cover;
}
.voucher-footer {
  height: 100%;
  padding: 0 10px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 12px;
}
.voucher-footer-text {
  text-align: left;
  width: 65%;
}
.voucher-header {
  height: 100%;
  border-bottom: dashed;
  border-width: 1px;
  border-radius: 8px;
}
.voucher-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.voucher-wrapper .voucher-redeem {
  margin-bottom: 0px;
  width: 30%;
}
.voucher-wrapper .voucher-confirm {
  margin-bottom: 0px;
  width: 68%;
}
.voucher-wrapper .voucher-cancel {
  margin-bottom: 0px;
  width: 22%;
}
</style>
